import React from 'react'
import { s } from '@vega/styled'
import { noop } from '@solta/ramda-extra'
import { Overlay } from '@vega/components'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'

import DateFnsAdapter from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'

import DateRangePicker from '@mui/lab/StaticDateRangePicker'

function OverlayDateRangePicker({ value = [new Date(), new Date()], onChange = noop }) {
  return (
    <LocalizationProvider dateAdapter={DateFnsAdapter}>
      <Overlay
        label="Date range"
        popoverStyle={s('border-solid border-1 border-grey-200 bg-white', {
          borderRadius: 12,
        })}
      >
        <DateRangePicker
          value={value}
          onChange={onChange}
          renderInput={(startProps, endProps) => {
            return (
              <>
                <TextField {...startProps} />
                <Box sx={{ mx: 2 }}> to </Box>
                <TextField {...endProps} />
              </>
            )
          }}
        />
      </Overlay>
    </LocalizationProvider>
  )
}

export default OverlayDateRangePicker
